import React, { useState } from "react";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import CustomerDetailsPage from "pages/users/customers/customerDetails";
import { useTranslation } from "react-i18next";

const CustomersTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  handleDeleteRequest,
  followers,
  followings,
}) => {
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const { t } = useTranslation();
  const [supportedLang] = useState("en");
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          table={{
            list: data,
            listTitle: t("customers.list_title"),
            createBtnTitle: false,
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: t("customers.col_id") },
              { accessor: "name", Header: t("customers.col_name"), sort: true },
              {
                accessor: "email",
                Header: t("customers.col_email"),
                sort: true,
              },
              {
                accessor: "phone_number",
                Header: t("customers.col_phone"),
                sort: true,
              },
              {
                accessor: "is_verified",
                Header: t("customers.col_verified"),
                sort: true,
              },
              { accessor: "profile_status", Header: t("customers.col_status") },
              { accessor: "Actions", Header: t("customers.col_actions") },
            ],
            isSearch: false,
            searchInputPlaceholder: t("customers.search_placeholder"),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className: "main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list
            headerChildren,
            details,
            openDeleteModal,
            // setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () => structure(supportedLang),
            validationSchema: validationSchema,
            deleteFun: deleteFun,
            title: id
              ? t("customers.edit_customer")
              : t("customers.new_customer"),
            submitTitle: id
              ? t("customers.btn_update")
              : t("customers.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          DetailsComponent={
            <CustomerDetailsPage
              details={details}
              actionsList={actionsList}
              followers={followers}
              followings={followings}
            />
          } //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default CustomersTemplate;
